import React, { useState } from 'react'
import { InputGroup, FormControl, Button } from 'react-bootstrap'
import emailjs from 'emailjs-com';
import classes from '../styles/App.module.css'

const Subscribe = () => {

    const [email, setEmail] = useState('')

    console.log(email)

    const sendMail = (email) => {

        // e.preventDefault()

        emailjs.sendForm(process.env.REACT_APP_GMAIL_SERVICE_ID, process.env.REACT_APP_GMAIL_TEMPLATE_ID, email, process.env.REACT_APP_MAIL_USER_ID)
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });

        setEmail('')
    }

    return (
        <div className="row">
            <div className="col-12">
                <InputGroup className={`mb-3 ${classes.subscribe}`}>
                    <FormControl
                        placeholder="Enter email address"
                        aria-label="Email"
                        // aria-describedby="basic-addon2"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                    <Button variant="outline-secondary" id="button-addon2" onClick={()=>sendMail(email)} >
                        Notify Me
                    </Button>
                </InputGroup>
            </div>
        </div>
    )
}

export default Subscribe